import { getRefs, getClustersRefs } from '@aytm/app/stats/lib/query/refs'
import { parseSavedPatterns } from '@aytm/app/stats/page/question-views/vq/lib/parse-saved-patterns'

const EMPTY = { expression: { status: { refs: {}, errors: [], tokens: [] } } }

// The refs a Virtual question depends on, keyed as its editor rows report them (`a<n>` per answer:
// pattern refs, base refs, cluster refs; `pattern` for the question-level expression). Read off the
// saved patterns with the same parse the rows run, so a question whose editor is folded away, and
// its rows unmounted, still knows which other questions its answer is built from. A caller that also
// needs the codes in use hands in the parse it already made.
export const calcDependableRefs = ({ parsed, modelClusters = [], ...args }) => {
  const { answers, question } = parsed || parseSavedPatterns(args)

  const refs = {}
  answers.forEach(({ pattern, base }, index) => {
    refs[`a${index + 1}`] = [
      getRefs(pattern.result),
      base ? getRefs(base.result) : [],
      getClustersRefs(modelClusters, pattern.result).concat(base ? getClustersRefs(modelClusters, base.result) : [])
    ]
  })

  const questionResult = question?.result || EMPTY
  refs.pattern = [getRefs(questionResult), getClustersRefs(modelClusters, questionResult)]

  return refs
}
